// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as historyObj from "history";
let history = historyObj.createBrowserHistory();

export default history;